import request from '@/utils/request'

// 订单列表
export function fetchList(data) {
	return request({
		url: '/oms/userOrder/queryOosOrderList',
		method: 'POST',
		data
	})
}



// WEBPACK FOOTER //
// ./src/api/oms/problem-order.js